'use client';
import {useTranslations} from 'next-intl';

export default function NoResult() {
  const t = useTranslations('SearchResult');

  return (
    <div className="flex flex-col items-center justify-center my-[10vh]">
      <h1 className="text-3xl font-bold my-4 text-[#e22319]">
        {t('noResultFound')}
      </h1>
      <p className="max-w-[460px]">{t('thereIsNoResult')}</p>
    </div>
  );
}
